import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const listarPeriodicidade = createAsyncThunk("/Periodicidade/ListarPeriodicidade", async () => {
  try {
    const data = await api.get("/Periodicidade/ListarPeriodicidade");
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});
